module.exports = __webpack_public_path__ + "static/media/edit.e6040978.png";